export default __webpack_public_path__ + "static/media/Lista(G).8b304d82.svg";